import request from '@/utils/ajax';

export function deteleAccount(data){
  return request({
    url: `/wx/manage/wxAccount/delete`,
    method: 'post',
    data: data
  });
}

//添加或者更新
export function saveAccount(data){
  return request({
    url: `/wx/manage/wxAccount/save`,
    method: 'post',
    data: data
  });
}

export function updateAccount(data){
  return request({
    url: `/wx/manage/wxAccount/update`,
    method: 'post',
    data: data
  });
}
